import { create } from 'zustand';
import { IOrganizationData } from '../../../types';

export type LegalModalStoreState = {
  organisation: IOrganizationData | null;
  legalPdfUrl: string | null;

  setOrganisation: (data: IOrganizationData) => void;
  setPdfUrl: (url: string | null) => void;

  showPrivacyModal: boolean;
  setShowPrivacyModal: (show: boolean) => void;

  showImprintModal: boolean;
  setShowImprintModal: (show: boolean) => void;
};

export const useLegalModalStore = create<LegalModalStoreState>(set => ({
  organisation: null,
  legalPdfUrl: null,
  showImprintModal: false,
  showPrivacyModal: false,

  setOrganisation: data =>
    set(state => ({
      ...state,
      organisation: data,
    })),

  setPdfUrl: url => {
    set(state => ({
      ...state,
      legalPdfUrl: url,
    }));
  },

  setShowImprintModal: show => {
    set(state => ({
      ...state,
      showImprintModal: show,
    }));
  },
  setShowPrivacyModal: show => {
    set(state => ({
      ...state,
      showPrivacyModal: show,
    }));
  },
}));
